import { queryKeys } from '../hooks/useTradeStationQueries';

/** Insert or replace a journal row in the React Query cache. */
export function upsertTradeJournalInCache(queryClient, journal) {
  if (!journal?.id) return;
  queryClient.setQueryData(queryKeys.tradeJournals, (old) => {
    const list = Array.isArray(old) ? old : [];
    const idx = list.findIndex((j) => j.id === journal.id);
    if (idx >= 0) {
      const next = [...list];
      next[idx] = { ...next[idx], ...journal };
      return next;
    }
    return [journal, ...list];
  });
}

export function removeTradeJournalFromCache(queryClient, id) {
  queryClient.setQueryData(queryKeys.tradeJournals, (old) => {
    if (!Array.isArray(old)) return old;
    return old.filter((j) => j.id !== id);
  });
}

/** Refetch active trade journal queries so lists update immediately. */
export function refreshTradeJournalsCache(queryClient) {
  return queryClient.refetchQueries({ queryKey: queryKeys.tradeJournals, type: 'active' });
}

export function notifyTradeJournalChanged(type = 'created') {
  const eventName = type === 'updated' ? 'tradeJournal:updated' : 'tradeJournal:created';
  try {
    window.dispatchEvent(new Event(eventName));
  } catch (_) {
    /* ignore */
  }
}
